import React from 'react';
import i18n from 'i18next';

export const MobxContext = React.createContext(null);
MobxContext.displayName = i18n.t('context.store.rootMobxStore');

export const MobxProvider = MobxContext.Provider;
